import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import { EASE } from "./motion";

// Signature transition: teal panel lifts away on every page load.
export const Curtain = () => {
  const { pathname } = useLocation();
  return (
    <motion.div
      key={pathname}
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-[80] flex items-center justify-center bg-teal"
      initial={{ clipPath: "inset(0% 0% 0% 0%)" }}
      animate={{ clipPath: "inset(0% 0% 100% 0%)" }}
      transition={{ duration: 0.9, ease: EASE, delay: 0.25 }}
    >
      <motion.img
        src="/img/mark-light.png"
        alt=""
        className="h-16 w-auto"
        initial={{ opacity: 1, y: 0 }}
        animate={{ opacity: 0, y: -24 }}
        transition={{ duration: 0.5, ease: EASE, delay: 0.15 }}
      />
    </motion.div>
  );
};
